export default function PillBadge({
    text,
    action = 'success'
}) {
    return (
        <span className={`badge rounded-pill bg-${action}`}>{text}</span>
    )
}
